import React, { createContext, ReactNode, useContext } from "react";

import { IPostSalesInvoiceService } from "../types/services/post-sales-invoice-service";

const PostSalesInvoiceServiceContext = createContext<IPostSalesInvoiceService>(
  undefined as any,
);

interface PostSalesInvoiceServiceProviderProps {
  service: IPostSalesInvoiceService;
  children: ReactNode;
}

function PostSalesInvoiceServiceProvider (
  props: PostSalesInvoiceServiceProviderProps,
) {
  const { service, children } = props;

  return (
    <PostSalesInvoiceServiceContext.Provider value={service}>
      {children}
    </PostSalesInvoiceServiceContext.Provider>
  );
}

function usePostSalesInvoiceService () {
  return useContext(PostSalesInvoiceServiceContext);
}

export { PostSalesInvoiceServiceProvider, usePostSalesInvoiceService };
